import React from 'react';
import { Row, Col } from 'react-bootstrap';

import styles from '../HeroSection/heroSection.module.css';
import BackgroundImage from 'gatsby-background-image';
import globalstyles from '../../Global/global.module.css';
import { Link } from 'gatsby';

const HeroSection = ({ heroImage, title, heroImageText, link, link_title }) => {
	return (
		<Row className={styles.heroSection}>
			<BackgroundImage Tag="section" fluid={heroImage} style={{ width: '100%', height: '95vh' }}>
				<Col xs="12" className={styles.contentHolder}>
					<Row className={styles.content}>
						<h1 className={globalstyles.h1}>{heroImageText}</h1>
						<Link to={link} className={styles.btn}>
							{link_title}
						</Link>
					</Row>
				</Col>
			</BackgroundImage>
		</Row>
	);
};
export default HeroSection;
